<template>
  <v-btn v-on:click="buttonEvent">
    <!--<v-icon v-if="tableView" sm4 color="info"> mdi-calendar-week</v-icon>-->
    <v-icon v-if="tableView" sm4 color="info"> mdi-arrow-down</v-icon>
    <v-icon v-if="!tableView" sm4 color="info"> mdi-table</v-icon>

    <span v-if="tableView" class="grey--text"> &nbsp;&nbsp;&nbsp; {{ $t('my_schedule_view.switch_btn_to_timeline') }} </span>
    <!--<span v-if="tableView" class="grey--text"> &nbsp;&nbsp;&nbsp; {{ $t('my_schedule_view.switch_btn_to_calendar') }} </span>-->
    <span v-if="!tableView" class="grey--text"> &nbsp;&nbsp;&nbsp; {{ $t('my_schedule_view.switch_btn_to_table') }} </span>
  </v-btn>
</template>

<script>
  export default {

    name: 'mySwitchButton',
    props: {
      tableView: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      buttonEvent() {
        this.$emit('buttonEvent')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// VueSrc/Education/schedule_components/mySwitchButton.vue